module.exports = "https://media.zlongame.com/media/pictures/cn/vipCenter/assets/img/appkeyIcon/icon_1486458782785.png";